import {Skill} from "./skill";
import {ITechnicalCompetence} from "./i-technical-competence";
import {KnowledgeItem} from "./knowledge-item";
import {BehaviouralIndicator} from "./behavioural-indicator";

export class TechnicalCompetence {
    public constructor(public skill: Skill,
                       public knowledgeItems: Array<KnowledgeItem>,
                       public behaviouralIndicators: Array<BehaviouralIndicator>) {
    }

    public static fromInterface(iTechnicalCompetence: ITechnicalCompetence): TechnicalCompetence {
        return new TechnicalCompetence(Skill.fromInterface(iTechnicalCompetence.skill),
            iTechnicalCompetence.knowledgeItems && iTechnicalCompetence.knowledgeItems
                .map(iKnowledgeItem => KnowledgeItem.fromInterface(iKnowledgeItem)),
            iTechnicalCompetence.behaviouralIndicators && iTechnicalCompetence.behaviouralIndicators
                .map(iBehaviouralIndicator => BehaviouralIndicator.fromInterface(iBehaviouralIndicator)));
    }
}
